import { Link, Menu, MenuButton, MenuItem } from "@aws-amplify/ui-react";
import React, { useEffect, useRef } from "react";
import { AiOutlineBell } from "react-icons/ai";
// import { BiChevronDown } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../../context/DataContext";
import Modal from "../Modal/Modal";
import { useAuth0 } from "@auth0/auth0-react";
import ProfilePictureModal from "../ProfilePopup/ProfilePictureModal";
import { useToolTip } from "../Tooltip/ToolTip";
import ToolTipComponent from "../Tooltip/ToolTipComponent";
import { logError } from "../../utils/errorHandling";


const HeaderNav = () => {
  const { tooltipText, position, visible, showTooltip, moveTooltip, hideTooltip } = useToolTip()
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = React.useState<boolean>(false);
  const { updateState } = useMyContext();
  const [editImage, setEditImage] = React.useState<boolean>(false);
  const [profileImage, setProfileImage] = React.useState<boolean>(false);
  const [emailId, setEmailId] = React.useState("");
  const menuRef = useRef<HTMLDivElement>(null);
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const { logout, user } = useAuth0();
  const username = (user?.preferred_username) || "Moonjelly User";
  const [customProfileImage, setCustomProfileImage] = React.useState<string | null>(null);

  useEffect(() => {
    const saved = localStorage.getItem("userProfileImage");
    if (saved) {
      setCustomProfileImage(saved);
    }
  }, []);

  const displayImage = customProfileImage || (params.size === 0 ? user?.picture : "/default.png");

  const chatHandler = (sidebar, route) => {
    updateState("sideBar", sidebar)
    const mainRoute = route + (queryString ? queryString : "");
    navigate(mainRoute);
    setMenuOpen(false);
  }

  const mouseEnterFunction = (event) => {
    showTooltip("change profile picture", event);
    setEditImage(true)
  }
  const mouseLeaveFunction = () => {
    hideTooltip()
    setEditImage(false)
  }


  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    void logout({ logoutParams: { returnTo: window.location.origin } }).catch((error) => {
      logError("Logout failed", error);
    });
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const email = user?.email || "No email set";
  useEffect(() => {
    setEmailId(email)
  }, [username]);
  return (
    <>
      <div className="right-menu" ref={menuRef}>
        <ToolTipComponent text={tooltipText} position={position} visible={visible} isPositionSet={true} />
        <div className="github-link">
          <Link href="https://docs.google.com/forms/d/e/1FAIpQLScX29tGPRMJ4lGc0-ED9N1Clyh20M-UlLX8xvqhr5toX0xiFA/viewform"
                target="_blank" 
                rel="noopener noreferrer">
            <img src="/svg/feedback.svg" alt="Feedback" width="20" height="20" />
          </Link>
        </div>
        <div className="github-link">
          <Link >
            <AiOutlineBell />
          </Link>
        </div>
        <div className="header-menu">
          <Menu
            isOpen={menuOpen}
            menuAlign="end"
            trigger={
              <MenuButton variation="menu"
                onClick={toggleMenu}
                onMouseEnter={(event) => showTooltip("User Profile", event)}
                onMouseMove={(event) => moveTooltip(event)}
                onMouseLeave={hideTooltip}
              >
                <div className="header-avatar">
                  <img alt="avatar" src={displayImage} />
                </div>
                <div className="user-name">
                  {username}
                </div>
                <div className="icon" style={{ fontSize: "20px" }}>
                  {/* {<BiChevronDown fontWeight={100} />} */}
                </div>
              </MenuButton>
            }
          >

            <div className="menu-container">
              <MenuButton variation="menu">
                <div className="header-avatar"
                  onMouseEnter={mouseEnterFunction}
                  onMouseMove={(event) => moveTooltip(event)}
                  onMouseLeave={mouseLeaveFunction}
                  onClick={() => { setProfileImage(!profileImage) }}
                >
                  {
                    editImage ?
                      <img alt="avatar" src={"/svg/editIcon.svg"} />
                      :
                      <img alt="avatar" src={displayImage} />

                  }
                </div>
                <div className="user-name">
                  <b>{username}</b>
                  <div>{emailId}</div>
                </div>
              </MenuButton>
              {
                window.location.href.includes("chat") ?
                  <MenuItem className="buttoncolor" onClick={() => chatHandler("", "/")}>AI Hub</MenuItem>
                  :
                  <MenuItem className="buttoncolor" onClick={() => chatHandler("chatbar", "/chat")}>Chat</MenuItem>

              }
              <MenuItem className="buttoncolor" onClick={handleLogout}>Logout</MenuItem>
            </div>

          </Menu>
        </div>
      </div>
      <Modal onClose={() => setProfileImage(false)} isOpen={profileImage}>
        <ProfilePictureModal
          setProfileImage={setProfileImage}
          currentImage={customProfileImage}
          onSave={(img) => {
            if (img) {
              localStorage.setItem("userProfileImage", img);
              setCustomProfileImage(img);
            } else {
              localStorage.removeItem("userProfileImage");
              setCustomProfileImage(null);
            }
          }}
        />
      </Modal>
    </>
  );
};

export default HeaderNav;